import styled from "styled-components";

export const AvatarImg = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;

  overflow: hidden;
  img {
    display: block;
    max-width: 100%;
  }
`;
